import React, { useState } from 'react';
import Card from 'react-bootstrap/Card';
import { AvatarParams } from '../Avatar/Avatar';
import AvatarGroup, {
  AvatarGroupSize,
  AvatarGroupStyle,
} from '../Avatar/AvatarGroup';
import Checkbox from '../Checkbox/Checkbox';

export type UserCardProps = {
  className?: string;
  value: string;
  title?: string;
  avatars: AvatarParams[];
  onClick?: React.MouseEventHandler;
  selected?: boolean;
};

const UserCardGrouped = ({
  className,
  value,
  title = 'Children',
  avatars,
  selected,
  onClick,
}: UserCardProps) => {
  const [isSelected, setSelected] = useState(
    selected !== undefined ? selected : false
  );

  const handleToggle = (e?: any) => {
    setSelected((prevOpen) => !prevOpen);
    onClick && onClick(e);
  };

  const handleSelect = () => {
    setSelected(!isSelected);
  };

  return (
    <Card
      bsPrefix={'cnd-user-card'}
      onClick={handleToggle}
      className={`d-flex flex-lg-column align-items-center position-relative ${className} ${
        isSelected ? 'selected' : ''
      }`}
    >
      <Checkbox
        value={value}
        className={'position-absolute'}
        checked={isSelected}
        onChange={handleSelect}
      />
      <div
        className={
          'cnd-user-card--image-wrapper d-flex justify-content-center align-items-center'
        }
      >
        <AvatarGroup
          avatars={avatars}
          groupSize={AvatarGroupSize.MINIMIZED}
          groupStyle={AvatarGroupStyle.STACKED}
          maxAvatarsPerGroup={3}
        />
      </div>
      <Card.Body className={'d-flex flex-column align-items-lg-center'}>
        <Card.Title>{title}</Card.Title>
        <Card.Subtitle>{`${avatars.length} family members`}</Card.Subtitle>
      </Card.Body>
    </Card>
  );
};

export default UserCardGrouped;
